var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginCard = function SvgLoginCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__a)",
    d: "m44.413 1.025 3.64 4.133a3 3 0 0 0 2.453 1.021l5.483-.362a3.025 3.025 0 0 1 3.211 3.21l-.362 5.484a2.96 2.96 0 0 0 1.021 2.454l4.133 3.639a3.013 3.013 0 0 1 0 4.528l-4.133 3.64a3 3 0 0 0-1.02 2.453l.361 5.483a3.025 3.025 0 0 1-3.21 3.211l-5.484-.362a2.96 2.96 0 0 0-2.453 1.02l-3.64 4.134a3.013 3.013 0 0 1-4.528 0l-3.639-4.133a3 3 0 0 0-2.454-1.021l-5.483.362a3.025 3.025 0 0 1-3.21-3.21l.361-5.484a2.96 2.96 0 0 0-1.02-2.454l-4.134-3.639a3.013 3.013 0 0 1 0-4.528l4.133-3.64a3 3 0 0 0 1.021-2.453l-.362-5.483a3.025 3.025 0 0 1 3.211-3.211l5.483.362a2.96 2.96 0 0 0 2.454-1.02l3.64-4.134a3.013 3.013 0 0 1 4.527 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__b)",
    d: "M10.18 35.752h23.119V73H14.198a4.023 4.023 0 0 1-4.018-4.018z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__c)",
    d: "M33.2 35.753h37.988v33.23a4.006 4.006 0 0 1-4.002 4.001H33.2V35.737z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.66 48.547h-3.03v24.437h3.03z",
    opacity: 0.46
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__d)",
    d: "M10.18 51.084h17.322c1.581 0 2.948-1.12 3.26-2.668L33.2 36.264l8.743 24.354a4.48 4.48 0 0 0 4.216 2.964h25.03V35.737H10.03l.148 15.33z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.755 48.547h-2.552v24.437h2.552z",
    opacity: 0.46
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__e)",
    d: "m71.188 36.28 9.748 10.505c.626.675-.428 1.762-1.35 1.762H43.26a3.52 3.52 0 0 1-2.947-1.58l-7.114-10.688v-.527z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__f)",
    d: "m71.188 35.752 9.748 10.506c.626.675.148 1.762-.774 1.762H43.26a3.52 3.52 0 0 1-2.947-1.58l-7.114-10.688z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__g)",
    d: "M10.033 36.28.284 46.784c-.625.675.429 1.762 1.35 1.762H23.14a3.52 3.52 0 0 0 2.948-1.58L33.2 36.278v-.527z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__h)",
    d: "M10.032 35.752.284 46.258c-.626.675-.149 1.762.773 1.762H23.14a3.52 3.52 0 0 0 2.948-1.58L33.2 35.751z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.115 23.585c-1.235 0-2.306-.445-3.162-1.317-.856-.873-1.3-1.927-1.3-3.162s.428-2.305 1.3-3.162 1.927-1.3 3.162-1.3 2.272.428 3.161 1.3 1.318 1.927 1.318 3.162-.445 2.272-1.318 3.162c-.872.889-1.926 1.317-3.161 1.317m-1.285-3.178q.544.543 1.285.543t1.284-.543c.362-.362.527-.79.527-1.301s-.181-.939-.527-1.3a1.76 1.76 0 0 0-1.284-.544q-.74 0-1.285.543c-.362.362-.526.79-.526 1.301s.18.939.526 1.3m3.804 10.539h-3.227l10.226-16.138h3.227zm9.534.18c-1.235 0-2.305-.444-3.161-1.317-.873-.872-1.301-1.926-1.301-3.161s.428-2.306 1.3-3.162c.874-.873 1.927-1.3 3.162-1.3s2.273.427 3.162 1.3c.873.873 1.317 1.927 1.317 3.162s-.444 2.272-1.317 3.161c-.873.873-1.927 1.318-3.162 1.318m-1.284-3.177q.543.543 1.284.543c.494 0 .922-.181 1.268-.543s.527-.79.527-1.301-.18-.939-.527-1.301a1.7 1.7 0 0 0-1.268-.544q-.741 0-1.284.544c-.362.362-.527.79-.527 1.3 0 .511.181.94.527 1.302"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__i)",
    d: "M69.691 31.126a.873.873 0 1 0 0-1.746.873.873 0 0 0 0 1.746"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login-card_svg__j)",
    d: "M17.639 6.561 15.7 5.867a.593.593 0 0 0-.758.359l-.694 1.937c-.11.309.05.648.358.758l1.938.694c.308.11.648-.05.758-.358l.694-1.938a.593.593 0 0 0-.358-.758"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#login-card_svg__k)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.722,
    d: "M64.092 7.398s.626-1.927 2.47-2.108"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__a",
    x1: 42.149,
    x2: 42.149,
    y1: 0,
    y2: 45.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0BEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__b",
    x1: 21.492,
    x2: 22.151,
    y1: 40.528,
    y2: 72.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__c",
    x1: 52.202,
    x2: 52.202,
    y1: 37.4,
    y2: 131.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__d",
    x1: 40.61,
    x2: 40.61,
    y1: 35.852,
    y2: 65.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A3A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__e",
    x1: 47.212,
    x2: 76.012,
    y1: 52.137,
    y2: 21.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__f",
    x1: 53.14,
    x2: 59.776,
    y1: 11.678,
    y2: 60.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__g",
    x1: 23.354,
    x2: 4.648,
    y1: 48.712,
    y2: 29.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__h",
    x1: 5.47,
    x2: 26.498,
    y1: 61.589,
    y2: 23.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__i",
    x1: 66.925,
    x2: 71.42,
    y1: 33.777,
    y2: 28.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A96FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#AF75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__j",
    x1: 16.643,
    x2: 15.128,
    y1: 10.824,
    y2: 1.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "login-card_svg__k",
    x1: 63.68,
    x2: 66.99,
    y1: 6.344,
    y2: 6.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F0"
  })))));
};
export default SvgLoginCard;